module.exports = __webpack_public_path__ + "static/gyaf-web-2f55c30545f3335900207d3c9b3d8f2c.jpg";